import React, { useState, useEffect } from "react";
import { connect } from 'react-redux';
import InputUI from "./InputUI";

const formatToCustomPattern = (input) => {
  if (!input) return "";

  if (!input.toString().includes(",")) return input;

  const normalized = input.replace(/\./g, "").replace(",", ".");

  const parsed = parseFloat(normalized);
  if (isNaN(parsed)) return input;


  const parts = parsed
    .toFixed(2)
    .split(".");

  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  const decimalPart = parts[1];

  return `${integerPart},${decimalPart}`;
};

const CustomNumberInputUI = (props) => {
  const [value, setValue] = useState(props.value || "");

  useEffect(() => {
    if (props.value !== value) {
      setValue(props.value || "");
    }
  }, [props.value]);

  const handleChange = (e) => {

    const input = e.target.value;
    let sanitized = input.replace(/[^0-9.,]/gi, "");

    const commaMatches = sanitized.match(/,/g) || [];
    if (commaMatches.length > 1) {
      sanitized = sanitized.replace(/,(?=[^,]*,)/g, "");
    }

    const dotMatches = sanitized.match(/\./g) || [];
    if (dotMatches.length > 1) {
      sanitized = sanitized.replace(/\.(?=[^.]*\.)/g, "");
    }

    setValue(sanitized);

    if (props.onChange) {
      const fakeEvent = {
        ...e,
        target: {
          ...e.target,
          value: sanitized
        }
      };
      props.onChange(fakeEvent);
    }
  };

  const handlePaste = (e) => {
    const text = e.clipboardData.getData('text');
    if (/[a-df-z]/i.test(text)) {
      e.preventDefault();
    }
  };

  const handleBlur = () => {
    const formatted = formatToCustomPattern(value);
    setValue(formatted);
  };

  return (
    <InputUI
      {...props}
      value={value}
      onPaste={handlePaste}
      onChange={handleChange}
      onBlur={handleBlur}
      isValidation={false}
    />
  );
};

const mapStateToProps = () => ({});

export default connect(mapStateToProps)(CustomNumberInputUI);